import { IBanner } from '../utils/entities/interface';
import { post, get, del } from './https';

const fetchBanners = async (): Promise<IBanner[]> => {
  const response = await get('/api/v1/admin/home-banner/list');
  if (response.status == 200 && Array.isArray(response.data?.data)) {
    return response.data.data;
  } else {
    throw Error('Error while Fetching Banners');
  }
};

// imageUrl, destination, position, data
const saveBanner = async (
  banner: Partial<{
    imageUrl: string;
    destination: string;
    position: number;
    data: string;
  }>,
): Promise<number> => {
  const response = await post('/api/v1/admin/home-banner/create', banner);
  if (response.status == 201) {
    return 201;
  } else {
    throw Error('Failed while Uploading new banner');
  }
};

const editBanner = async ({
  id,
  imageUrl,
  destination,
  position,
  data,
}: {
  id: string;
  imageUrl: string;
  destination: string;
  position: number;
  data: string;
}) => {
  const response = await post('/api/v1/admin/home-banner/edit', {
    id,
    imageUrl,
    destination,
    position,
    data,
  });
  if (response.status == 200) {
    return 200;
  } else {
    throw Error('Failed To Update Banner');
  }
};

const deleteBanner = async (bannerId: string): Promise<boolean> => {
  const response = await del(`/api/v1/admin/home-banner/delete/${bannerId}`);
  if (response.status) {
    return true;
  } else {
    throw Error('Failed To Delete Banner');
  }
};

export { saveBanner, fetchBanners, editBanner, deleteBanner };
